// import { generateActions } from "helpers/generateActions";
export const GET_CONTAINERS = "GET_CONTAINERS";
export const GET_CONTAINERS_SUCCESS = "GET_CONTAINERS_SUCCESS";

export const API_ERROR = "API_ERROR";